import styled from '@emotion/styled';
import { Stack } from '@pairy/pds-react';

export const LinkWrapper = styled(Stack)`
  &:hover {
    cursor: pointer;
  }
`;
